import { render, staticRenderFns } from "./SPIFProfileBalanceSheet.vue?vue&type=template&id=52c8414c"
import script from "./SPIFProfileBalanceSheet.vue?vue&type=script&lang=js"
export * from "./SPIFProfileBalanceSheet.vue?vue&type=script&lang=js"
import style0 from "./SPIFProfileBalanceSheet.vue?vue&type=style&index=0&id=52c8414c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports